@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {

  <div class="title-area">
    <h2 class="title">90秒アンケート 回答<span class="target-month">{{ targetMonth }}分</span></h2>
  </div>

  <div class="card">
    <h3 class="with-note">あなたについて（本人の状態）</h3>
    <p class="card-note">質問の1から5まで、会社の仕事について、回答してください。</p>

    @for (q of selfQuestions; track q.no) {
      <div class="scale-question">
        <div class="q-text"><span class="q-no">{{ q.no }}</span><span class="q-body">{{ q.text }}</span></div>
        <div class="scale-row">
          @for (opt of scaleOptions; track opt.value) {
            <label class="scale-option">
              <span class="scale-value">{{ opt.value }}</span>
              <input type="radio" [name]="q.key" [(ngModel)]="answers[q.key]" [value]="opt.value">
              <span class="scale-label">{{ opt.label }}</span>
            </label>
          }
        </div>
      </div>
    }
  </div>

  <div class="card">
    <h3 class="with-note">職場/店舗について（職場/店舗の状態）</h3>
    <p class="card-note">質問の6から17までは、会社の仕事や職場について、18以降は組合について、回答してください。</p>

    <div class="workplace-select-block">
      <div class="workplace-select-title">
        <span class="workplace-select-label">＜回答する職場/店舗＞</span>
        <span class="note">※ 原則、前月から変更しないでください。</span>
      </div>
      <button type="button" class="select-btn" (click)="onSelectWorkplace()">選択</button>

      @if (workplaceSelection.workplaceId != null) {
        <div class="selected-workplace">
          <span class="selected-workplace-path">{{ workplaceSelection.workplacePath }}</span>
          @if (workplaceSelection.scopeType === 'part') {
            <span class="selected-workplace-part">
              （{{ workplaceSelection.partName }}：{{ workplaceSelection.partMemberCount }}人）
            </span>
          }
        </div>
      }
    </div>

    @for (q of workplaceQuestions; track q.no) {
      <div class="scale-question">
        <div class="q-text"><span class="q-no">{{ q.no }}</span><span class="q-body">{{ q.text }}</span></div>
        <div class="scale-row">
          @for (opt of scaleOptions; track opt.value) {
            <label class="scale-option">
              <span class="scale-value">{{ opt.value }}</span>
              <input type="radio" [name]="q.key" [(ngModel)]="answers[q.key]" [value]="opt.value">
              <span class="scale-label">{{ opt.label }}</span>
            </label>
          }
        </div>
      </div>
    }

    <div class="checkbox-question">
      <div class="q-text">
        <span class="q-no">{{ q13No }}</span>
        <span class="q-body">
          {{ q13Text }}
          <span class="q-note">※ 優先度の高い順に最大{{ q13MaxSelect }}つまで選択</span>
        </span>
      </div>
      <div class="priority-grid">
        @for (opt of q13Options; track opt.value) {
          <label
            class="priority-checkbox"
            [class.checked]="isQ13Selected(opt.value)"
            [class.disabled]="isQ13Disabled(opt.value)"
            (click)="toggleQ13(opt.value); $event.preventDefault()"
          >
            @if (getQ13Priority(opt.value); as num) {
              <span class="priority-num">{{ num }}</span>
            } @else {
              <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                [disabled]="isQ13Disabled(opt.value)">
            }
            {{ opt.label }}
          </label>
        }
      </div>
    </div>

    <div class="checkbox-question">
      <div class="q-text"><span class="q-no">{{ q14.no }}</span><span class="q-body">{{ q14.text }}</span></div>
      <div class="checkbox-grid">
        @for (opt of q14.options; track opt.value) {
          <label class="checkbox-label">
            <input type="checkbox" [checked]="isChecked(q14.key, opt.value)" (change)="toggleChecked(q14.key, opt.value)">
            {{ opt.label }}
          </label>
        }
      </div>
    </div>

    <div class="radio-question">
      <div class="q-text"><span class="q-no">{{ q15No }}</span><span class="q-body">{{ q15Text }}</span></div>
      <div class="radio-list">
        @for (opt of q15Options; track opt.value) {
          <label class="radio-label">
            <input type="radio" name="q15" [(ngModel)]="answers.q15" [value]="opt.value">
            {{ opt.label }}
          </label>
        }
      </div>
    </div>


    <div class="radio-question-inline">
      <div class="q-text"><span class="q-no">{{ q17No }}</span><span class="q-body">{{ q17Text }}</span></div>
      <div class="radio-group">
        @for (opt of yesNoOptions; track opt.value) {
          <label class="radio-label">
            <input type="radio" name="q17" [(ngModel)]="answers.q17" [value]="opt.value">
            {{ opt.label }}
          </label>
        }
      </div>
    </div>

    <div class="radio-question-inline">
      <div class="q-text"><span class="q-no">{{ q18No }}</span><span class="q-body">{{ q18Text }}</span></div>
      <div class="radio-group">
        @for (opt of yesNoOptions; track opt.value) {
          <label class="radio-label">
            <input type="radio" name="q18" [(ngModel)]="answers.q18" [value]="opt.value">
            {{ opt.label }}
          </label>
        }
      </div>
    </div>
    <!-- 組合についての設問のため、職場についての設問（旧17・18）の後ろに置く（保存キーは q16 のまま、表示番号は18） -->
    <div class="checkbox-question">
      <div class="q-text"><span class="q-no">{{ q16.no }}</span><span class="q-body">{{ q16.text }}</span></div>
      <div class="checkbox-grid">
        @for (opt of q16.options; track opt.value) {
          <label class="checkbox-label">
            <input type="checkbox" [checked]="isChecked(q16.key, opt.value)" (change)="toggleChecked(q16.key, opt.value)">
            {{ opt.label }}
          </label>
        }
      </div>
    </div>

    <div class="scale-question">
      <div class="q-text"><span class="q-no">{{ q19No }}</span><span class="q-body">{{ q19Text }}</span></div>
      <div class="scale-row">
        @for (opt of participationScaleOptions; track opt.value) {
          <label class="scale-option">
            <span class="scale-value">{{ opt.value }}</span>
            <input type="radio" name="q19" [(ngModel)]="answers.q19" [value]="opt.value">
            <span class="scale-label">{{ opt.label }}</span>
          </label>
        }
      </div>
    </div>

    <div class="checkbox-question">
      <div class="q-text"><span class="q-no">{{ q20.no }}</span><span class="q-body">{{ q20.text }}</span></div>
      <div class="checkbox-grid">
        @for (opt of q20.options; track opt.value) {
          <label class="checkbox-label">
            <input type="checkbox" [checked]="isChecked(q20.key, opt.value)" (change)="toggleChecked(q20.key, opt.value)">
            {{ opt.label }}
          </label>
        }
      </div>
    </div>

    <div class="checkbox-question">
      <div class="q-text"><span class="q-no">{{ q21.no }}</span><span class="q-body">{{ q21.text }}</span></div>
      <div class="checkbox-grid">
        @for (opt of q21.options; track opt.value) {
          <label class="checkbox-label">
            <input type="checkbox" [checked]="isChecked(q21.key, opt.value)" (change)="toggleChecked(q21.key, opt.value)">
            {{ opt.label }}
          </label>
        }
      </div>
    </div>
  </div>

  <div class="submit-area">
    <div class="submit-warning">回答後の変更はできません。</div>
    <div class="submit-buttons">
      <button mat-raised-button class="cancel-btn" [disabled]="isSubmitting" (click)="onCancel()">キャンセル</button>
      <button mat-raised-button class="yes-btn" [disabled]="!isSubmitEnabled()" (click)="onSubmit()">
        @if (isSubmitting) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          回答
        }
      </button>
    </div>
  </div>
}
